// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IRatingSchema } from '../rating/RatingSchema';

export interface IPublicV1ReviewSaveRequestSchema {
  negativeReview?: TPublicV1ReviewSaveRequestSchema_NegativeReview;
  /** Реалти айди объявления **/
  offerRealtyId: number;
  positiveReview?: TPublicV1ReviewSaveRequestSchema_PositiveReview;
  /** Рейтинг/оценка по критериям **/
  rating: IRatingSchema;
  /** Статус поездки **/
  tripStatus: ETripStatus;
}

export type TPublicV1ReviewSaveRequestSchema_NegativeReview = string | any;

export type TPublicV1ReviewSaveRequestSchema_PositiveReview = string | any;

export enum ETripStatus {
  /** Поездка не состоялась **/
  'Fail' = 'fail',
  /** Условия не подошли **/
  'FailedToAgree' = 'failedToAgree',
  /** Поездка планируется **/
  'Plan' = 'plan',
  /** Поездка состоялась **/
  'Success' = 'success',
}
